import React from "react";
import "../../../../assets/styles/main.css";
import "../../../../assets/styles/responsive.css";

const B2bFaqs = () => {
  return (
    <div className="section home-faqs">
      <div className="container">
        <div className="content">
          <div className="content-area text-center">
            <h2 className="aos-item aos-init aos-animate">
              Frequently Asked Questions
            </h2>
            <div className="faq-para-wrapper">
              <p className="aos-item aos-init aos-animate">
                Discover clear and concise answers to your questions about
                Leadbud. Learn how to maximize your B2B prospecting efforts and
                make the most of your free 100 credits.
              </p>
            </div>
          </div>

          <div className="faqs-area" style={{ marginTop: "20px" }}>
            <div className="accordion" id="accordionExample">
              <div className="accordion-item aos-item aos-init aos-animate">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    1. What Is Leadbud, And How Does It Help With B2B
                    Prospecting?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Leadbud is a cutting-edge B2B prospecting tool designed to
                      simplify lead generation, automate outreach, and provide
                      actionable insights to boost your sales. It helps you
                      identify and connect with key decision-makers, filter
                      prospects with advanced targeting, and maximize your
                      ROI.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item aos-item aos-init aos-animate">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    2. How Do The Free 100 Credits Work In Leadbud?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Every new Leadbud account comes with 100 free credits,
                      allowing you to explore our features at no cost. Use these
                      credits to access prospect information, verify email
                      addresses, or run targeted searches. Once your credits
                      are used up, you can upgrade your plan to continue
                      enjoying our services.
                    </p>
                  </div>
                </div>
              </div>

              <div className="accordion-item aos-item aos-init aos-animate">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    3. Can Leadbud Help Me Find Decision-Makers In My Industry?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Absolutely! Leadbud’s advanced filters allow you to find
                      prospects based on job titles, departments, seniority
                      levels, and more. With accurate data and real-time email
                      verification, you can easily connect with decision-makers
                      relevant to your business.
                    </p>
                  </div>
                </div>
              </div>

              <div className="accordion-item aos-item aos-init aos-animate">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    4. Is My Data Secure With Leadbud?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes, Leadbud prioritizes data security and privacy. We use
                      industry-standard encryption to protect your information
                      and comply with all relevant data protection regulations,
                      ensuring a secure and reliable experience.
                    </p>
                  </div>
                </div>
              </div>

              <div className="accordion-item aos-item aos-init aos-animate">
                <h2 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    5. Can I Upgrade My Plan After Using The Free Credits?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Yes, upgrading your plan is easy! Once your free credits
                      are used, you can choose from a variety of subscription
                      options tailored to your needs. This ensures uninterrupted
                      access to all Leadbud features and tools for seamless
                      prospecting.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2bFaqs;
